
import { defineComponent } from '@vue/composition-api';
import { metaData } from '~/configuration/metaData';
import HeroSection from '~/components/v5/HeroSection.vue';
import SystemSection from '~/components/v5/home/SystemSection.vue';
import MemberStoriesSection from '~/components/v5/home/MemberStoriesSection.vue';
import StartTrainingSection from '~/components/v5/home/StartTrainingSection.vue';
import InspireFighterSection from '~/components/v5/home/InspireFighterSection.vue';

export default defineComponent({
  name: 'HomePage',
  components: {
    HeroSection,
    SystemSection,
    MemberStoriesSection,
    StartTrainingSection,
    InspireFighterSection,
  },
  head: {
    ...metaData.home,
  },
  setup() {
    const heroData = {
      title: 'We Choose Hard',
      subtitle: 'Because growth only lives where comfort ends. Boxing and martial arts training at home — real coaching, structure, and measured progress.',
      ctaText: 'Explore the System',
      ctaLink: 'the-system',
      tagline: 'New Year Sale • Best Deal of The Year',
      videoUrl: 'https://cdn-b.joinfightcamp.com/videos/Homepage_Hero_Video_NoAudio_001-2.mp4',
      mobileVideoUrl: 'https://cdn-b.joinfightcamp.com/videos/Hero_Video_9x16.mp4',

    };

    const endHeroData = {
      title: 'The Hardest Part Is Starting.',
      subtitle: 'You don\'t need to be ready — you just need a round. Choose your system, start where you are, and build the discipline that changes everything.',
      imageUrl: 'https://a.storyblok.com/f/152150/4096x2160/58d601ac8b/still-2025-02-22-114229-1.jpg',
      imageAlt: '',
      ctaText: 'Start Training',
      ctaLink: 'shop',
    };

    return {
      heroData,
      endHeroData,
    };
  },
});
